/**
 * Microsoft Entra ID (Workforce Tenant) Authentication Configuration
 *
 * Authenticates against the creativescombined.com workforce tenant.
 * External users (e.g. walshandco.co, umage.com) are onboarded as B2B
 * guests and gated by domainApprovalService on the AzureAPI side.
 *
 * Current Configuration:
 * - Tenant: creativescombined.com
 * - Tenant ID: 9fa30bc5-63d3-42b2-840d-1c532d002e53
 * - App Registration: CCStudio React App
 * - Client ID: 129b780b-6627-40cd-9d7e-9f0629062de3
 */

import { Configuration, PopupRequest, PublicClientApplication } from "@azure/msal-browser";

// Microsoft Entra ID (workforce tenant) configuration
export const msalConfig: Configuration = {
    auth: {
        clientId: "129b780b-6627-40cd-9d7e-9f0629062de3", // CCStudio React App
        authority: "https://login.microsoftonline.com/9fa30bc5-63d3-42b2-840d-1c532d002e53",
        redirectUri: window.location.origin, // Automatically uses current origin
        postLogoutRedirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "sessionStorage", // Store tokens in session storage
        storeAuthStateInCookie: false,
    },
};

// Scopes for API access
export const loginRequest: PopupRequest = {
    scopes: ["openid", "profile", "email", "offline_access"],
};

// API scopes - update this when you expose an API in your backend app registration
export const apiRequest = {
    scopes: [`api://${msalConfig.auth.clientId}/access_as_user`],
};

// Create and export the MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);
